<template>
  <w-sliding-popup type="setting" ref="slidingPopup" title="변수 설정" width="800px" @close="close()">
    <div slot="content">
      <el-row class="title-bar" type="flex" justify="space-between">
        <div class="vertical-center-box">
          <div class="title-h4 mr-r15">변수 설정</div>
          <em style="font-size:12px;">LIST 형태의 변수는 콤마( , )로 구분됩니다. </em>
        </div>
        <div class="vertical-center-box" align="right">
          <w-header-search-button @click="showSearchTool = !showSearchTool"></w-header-search-button>
        </div>
      </el-row>
      <el-table-wrapper ref="variableTable" :column-default="columnDefault" :data="variableList" :columns="tableColumns"
      :show-search-tool="showSearchTool" :show-custom-header="true" pagination :total="total" @pagination-change="handlerPaginationChange" @total-change="handlerPaginationChange">
        <template slot-scope="scope" slot="variable-slot">
          <el-input v-if="scope.row.type === 'JOB_VARIABLE'" v-model="variableValues[scope.$index]" :placeholder="scope.row.variableValue"></el-input>
          <el-input v-else v-model="scope.row.variableValue"></el-input>
        </template>
      </el-table-wrapper>
    </div>
    <div slot="footer">
      <el-button size="large" type="solid" @click="onSaveButtonClick">저장</el-button>
      <el-button size="large" @click="close">취소</el-button>
    </div>
  </w-sliding-popup>
</template>

<script>
import { isEqual, cloneDeep, differenceWith, isEmpty } from 'lodash';
import { getValueAfterCheckEmpty } from '@/utils/string';
import msgUtil from '@/utils/message';
import { columnDefault, defaultPagination } from '@/constants/table';
import amsSettingsApi from '@/api/settings/server/ams-settings';

const defaultFormatter = (row, column, value) => getValueAfterCheckEmpty(value);
const pagination = cloneDeep(defaultPagination);

export default {
  name: 'WTriggerNodeVarSettingPopup',
  props: {
    selectedTrgJob: {
      type: Object,
    },
    selectedTrgNode: {
      type: Object,
    },
  },
  data() {
    return {
      pagination,
      columnDefault,
      total: 0,
      showSearchTool: false,
      tableColumns: [
        { prop: 'taskName', label: '태스크 이름', searchable: true, sortable: true, formatter: defaultFormatter },
        { prop: 'variableId', label: '변수 아이디', searchable: true, sortable: true, formatter: defaultFormatter },
        { prop: 'variableValueType', label: '형태', width: 100, searchable: true, sortable: true, formatter: defaultFormatter },
        { prop: 'variableValue', label: '변수 값', width: 250, scopedSlot: 'variable-slot' },
      ],
      variableList: [],
      originalVariableList: [],
      variableValues: [],
    };
  },
  methods: {
    open() {
      this.$refs.slidingPopup.visible = true;
      this.$nextTick(() => {
        this.loadData();
      });
    },
    close() {
      this.$refs.slidingPopup.visible = false;
      this.variableValues = [];
    },
    loadData() {
      const tableParams = this.$refs.variableTable.getParameter();
      amsSettingsApi.getNodeVariableList({
        triggerId: this.selectedTrgJob.triggerId,
        jobId: this.selectedTrgJob.jobId,
        nodeId: this.selectedTrgNode.nodeId,
        ...tableParams,
      }).then((response) => {
        if (response.data.success) {
          this.variableList = cloneDeep(response.data.data);
          this.originalVariableList = response.data.data;
          this.total = response.data.total;
        }
      });
    },
    onSaveButtonClick() {
      const params = this.variableList.reduce((variables, value, index) => {
        if (value.type === 'JOB_VARIABLE' && !isEmpty(this.variableValues[index])) {
          value.variableValue = this.variableValues[index];
        }
        variables.push(value);
        return variables;
      }, []);
      const modifiedValues = differenceWith(params, this.originalVariableList, isEqual);
      const target = '변수';
      const action = msgUtil.action.MODIFY;
      if (isEmpty(modifiedValues)) {
        this.$message(msgUtil.getResultMsgData(action, target, true));
        this.close();
        return;
      }
      amsSettingsApi.updateTrgNodeVarValues(modifiedValues).then((response) => {
        if (response.data.success) {
          this.close();
        }
        this.$message(msgUtil.getResultMsgData(action, target, response.data.success));
      }).catch((e) => {
        this.$message(msgUtil.getResultMsgData(action, target, false));
        throw new Error(e);
      });
    },
    handlerPaginationChange(_pagination) {
      this.pagination = _pagination;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/server/AmsSettings/TriggerSetting/popup/TriggerNodeVarSettingPopup.vue